




































import { Vue, Component, Prop } from 'vue-property-decorator';
import {namespace} from "vuex-class";
import {LOADING_STATUS, IStringMap} from '@/constants/orders';
import {OTHER_ROUTES} from "@/constants/routes";
import { IOnOffHandlers } from '@/models/IOnOffHandlers';
import OrderCreationLoading from '@/views/components/Orders/OrderCreationLoading.vue';
import BulletPoints from "@/views/components/BulletPoints.vue";

const parseStep = (n: number | string): number => typeof n === 'string' ? parseInt(n, 10) : n;
const shipmentModule = namespace("shipment");
const userModule = namespace("userData");

@Component({
  name: 'OrderWrapper',
  components: {
    BulletPoints,
    OrderCreationLoading,
  },
})
export default class OrderWrapper extends Vue {
  @shipmentModule.Action('reset')
  private reset!: () => void;

  @userModule.Getter('getOfficePhoneNumberLink')
  private getOfficePhoneNumberLink!: string;

  @Prop({ default: ''})
  private pageTitle!: string;

  @Prop({ default: 1})
  private step!: number;

  @Prop({ default: 4})
  private numSteps!: number;
  private loadingState: string = LOADING_STATUS.BEFORE_LOADING;
  private readonly states: IStringMap = LOADING_STATUS;
  private myEvents: IOnOffHandlers = {};

  private created() {
    this.myEvents = this.$ons({
      "apiStatus:loading": this.loadingStart,
      "apiStatus:finish": this.loadingFinish,
      "apiStatus:error": this.loadingError,
    });
  }

  private destroyed() {
    this.$offs(this.myEvents);
  }

  private loadingStart() {
    this.loadingState = LOADING_STATUS.LOADING;
  }

  private loadingFinish(asId: string) {
    this.loadingState = LOADING_STATUS.FINISH;
  }

  private loadingError() {
    this.loadingState = LOADING_STATUS.BEFORE_LOADING;
  }

  private backToIndex() {
    this.reset();
    this.$router.push({name: OTHER_ROUTES.HOME});
  }

  private goToStep(n: number | string) {
    this.$emit('createOrderPage:goToStep', n);
  }
}
